import type {EditionApiModel} from '../../../../api/program/edition';
import type {Nullable} from '../../../utility-types';

export const isEditionEvergreen = (
  edition?: Nullable<EditionApiModel>,
): boolean => Boolean(edition?.is_autorestarting);
